import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Grid,
  Hidden,
  LinearProgress,
  Button,
  InputAdornment,
} from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Formik } from 'formik';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useDispatch } from 'react-redux';
import { SubHeading } from '../investors/components';
import { Location } from 'history';
import {
  AdminStrategyDetailsType,
  DistributorListType,
  strategyFormType,
} from '../../redux-store/types/api-types';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import { addStrategy, getStrategyById, updateStrategy } from '../../redux-store/actions/strategies';
import { addStrategyValidation } from '../../utils/schema';
import { MultipleSelect } from '../../lib/formik/MultipleSelectField';
import MFCheckbox from '../../lib/formik/Checkbox';
import { getDistributorsListForFilters } from '../../redux-store/actions';
import { showError } from '../../redux-store/actions/auth';
import UseRadioGroup from '../../lib/formik/Radio';
import { distributorMaster, STRATEGY_TYPE_OPTIONS } from '../../utils/constant';
import { ConfirmationDialog } from '../commonComponents';
import MFSelectField from '../../lib/formik/SelectField';
const strategyFeilds = {
  feeId: Date.now().toString(),
  id: '',
  fee: '',
  exitLoad: '',
  hurdleRate: '',
  profitShare: '',
  applicableForType: '',
  brokrageToDistributor: '',
  isOtherFeeApplicable: false,
  isActive: true,
};
export const filterStrategyFeeDetails = (strategy: strategyFormType[]): strategyFormType[] => {
  const filteredStrategyFeeDetails = strategy.filter(
    (strategy: strategyFormType) => strategy.isActive
  );

  return filteredStrategyFeeDetails;
};

export const isApplicableTypeDirect = (val: string) => {
  return distributorMaster[val] === distributorMaster.Direct;
};
export const isDistributorIsDistributor = (val: string) => {
  return distributorMaster[val] === distributorMaster.Distributor;
};
const initialValues: AdminStrategyDetailsType = {
  strategyFeeDetails: [],
  strategyName: '',
  strategyType: '',
  benchmark: '',
  isActive: true,
  distributorDetails: {
    distributorIds: [],
    distributors: [],
  },
  distributorIds: null,
  isApplicableForDirect: false,
  isApplicableForDistributor: false,
};

export default function AddStrategy({
  location,
}: {
  location: Location<{ StrategyId: string }>;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [strategyInitial, setStrategyInitial] = useState(initialValues);
  const [access, setAccess] = useState(true);
  const { StrategyId } = location.state || {};
  const [distributorList, setDistributorList] = useState<DistributorListType[]>([]);
  const [dialogbox, setDialogBox] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setLoading(true);
        const res = (await dispatch(
          getDistributorsListForFilters({ isActive: true })
        )) as unknown as DistributorListType[];
        setDistributorList(res);

        if (StrategyId) {
          const GetStrategyDetail = (await dispatch(
            getStrategyById(StrategyId)
          )) as unknown as AdminStrategyDetailsType;
          const {
            strategyName,
            strategyType,
            benchmark,
            strategyFeeDetails,
            isApplicableForDirect,
            isApplicableForDistributor,
            distributorDetails,
          } = GetStrategyDetail || {};

          setStrategyInitial((strategyInitial) => {
            return {
              ...strategyInitial,
              strategyName,
              strategyType,
              benchmark,
              isApplicableForDirect,
              isApplicableForDistributor,
              distributorDetails,
              distributorIds:
                distributorDetails && distributorDetails.distributorIds.length <= 0
                  ? null
                  : distributorDetails?.distributorIds || null,
              strategyFeeDetails:
                strategyFeeDetails?.length > 0
                  ? strategyFeeDetails.map((strategy) => {
                      return {
                        ...strategy,
                        feeId: strategy.id,
                        isOtherFeeApplicable: !!strategy.isOtherFeeApplicable,
                      };
                    })
                  : [{ ...strategyFeilds, feeId: Date.now().toString() }],
            };
          });
        } else {
          setStrategyInitial({
            ...strategyInitial,
          });
        }

        if (!isComponentAlive) return;
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, []);

  const onSubmit = async (values: AdminStrategyDetailsType) => {
    try {
      if (!values.isApplicableForDirect && !values.isApplicableForDistributor) {
        throw 'Please select Direct or Distributor';
      }

      if (values.strategyFeeDetails.length <= 0) {
        throw 'Please add at least one fee detail.';
      }
      if (
        (values.isApplicableForDirect &&
          !values.strategyFeeDetails.some((val) =>
            isApplicableTypeDirect(val.applicableForType)
          )) ||
        (values.isApplicableForDistributor &&
          !values.strategyFeeDetails.some((val) =>
            isDistributorIsDistributor(val.applicableForType)
          ))
      ) {
        throw 'Please add at least one fee detail with a type distribution and one with a type direct.';
      }

      const filteredStrategyFeeDetails = strategyInitial.strategyFeeDetails.filter(
        (initialDetail) => {
          return !values.strategyFeeDetails.some((detail) => detail.id === initialDetail.id);
        }
      );

      const updatedStrategyFeeDetails = [
        ...values.strategyFeeDetails,
        ...filteredStrategyFeeDetails.map((values) => {
          return { ...values, isActive: false };
        }),
      ].map((val) => {
        const { feeId, id, ...rest } = val;
        if (id) {
          return { id, ...rest };
        } else {
          return { ...rest };
        }
      });
      // eslint-disable-next-line
      const { distributorDetails, ...rest } = values;
      if (!StrategyId) {
        await dispatch(
          addStrategy({
            ...rest,
            strategyFeeDetails: updatedStrategyFeeDetails,
            distributorIds: rest.isApplicableForDistributor ? rest.distributorIds : [],
          })
        );
      } else {
        await dispatch(
          updateStrategy(StrategyId, {
            ...rest,
            strategyFeeDetails: updatedStrategyFeeDetails,
            distributorIds: rest.isApplicableForDistributor ? rest.distributorIds : [],
          })
        );
      }

      history.push(StrategyId ? 'strategy-details' : 'strategy-list', {
        StrategyId: StrategyId,
      });
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Formik
        initialValues={strategyInitial}
        onSubmit={onSubmit}
        enableReinitialize={true}
        validationSchema={addStrategyValidation(
          distributorList.map((distributor) => Number(distributor.id))
        )}>
        {({ handleSubmit, values, setValues }) => (
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
              py: { xs: 2, sm: 5 },
              pl: { xs: 0, sm: 5 },
              mt: { xs: 2, sm: 5 },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <Hidden smUp={true}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(StrategyId ? 'strategy-details' : 'strategy-list', {
                      StrategyId: StrategyId,
                    })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: '#1C2D47',
                  }}>
                  Back
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  my: 2,
                  py: 2,
                  pl: { xs: 3, sm: 0 },
                  color: 'primary.main',
                  bgcolor: 'rgba(238, 244, 251, 0.5)',
                }}>
                <PersonOutlineOutlinedIcon fontSize="large" />
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    pl: 1,
                  }}>
                  Strategy Setup
                </Typography>
              </Box>
            </Hidden>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Hidden only="xs">
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(StrategyId ? 'strategy-details' : 'strategy-list', {
                      // planId: StrategyId,
                      StrategyId: StrategyId,
                    })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
              </Hidden>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: '#1C2D47',
                  pl: { xs: 3, sm: 0 },
                }}>
                {StrategyId ? 'Edit Strategy' : 'Add Strategy'}
              </Typography>
            </Box>
            {loading ? (
              <LinearProgress sx={{ mt: 2 }} />
            ) : (
              <>
                <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                  <SubHeading
                    sx={{
                      color: 'common.blue',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                      ml: { xs: 3.5 },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}>
                    <Typography> {'Strategy Details'}</Typography>
                  </SubHeading>

                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="strategyName"
                      label="Strategy Name *"
                      placeholder="Enter Strategy Name"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFSelectField
                      name={`strategyType`}
                      label="Strategy type *"
                      items={Object.keys(STRATEGY_TYPE_OPTIONS)?.map((item) => ({
                        key: STRATEGY_TYPE_OPTIONS[item],
                        value: item,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name={`benchmark`}
                      label="Benchmark *"
                      placeholder="Enter Benchmark"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} sx={{ mt: 6 }}>
                    <Box sx={{ display: 'flex' }}>
                      <MFCheckbox
                        name={`isApplicableForDirect`}
                        label="Direct"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          let updateValues = [];

                          updateValues = values?.strategyFeeDetails?.map(
                            (value: strategyFormType) => {
                              return {
                                ...value,
                                isActive:
                                  value.applicableForType === distributorMaster.Direct
                                    ? event.target.checked
                                    : value.isActive,
                                applicableForType:
                                  !value.applicableForType && !event.target.checked
                                    ? distributorMaster.Distributor
                                    : value.applicableForType,
                              };
                            }
                          );

                          setValues({
                            ...values,
                            isApplicableForDirect: event.target.checked,
                            strategyFeeDetails: filterStrategyFeeDetails(updateValues),
                          });
                        }}
                      />
                      <MFCheckbox
                        name={`isApplicableForDistributor`}
                        label="Distributor"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          let updateValues = [];

                          updateValues = values?.strategyFeeDetails?.map(
                            (value: strategyFormType) => {
                              return {
                                ...value,
                                isActive:
                                  value.applicableForType === distributorMaster.Distributor
                                    ? event.target.checked
                                    : value.isActive,
                                brokrageToDistributor: event.target.checked
                                  ? value.brokrageToDistributor
                                  : '',
                                applicableForType:
                                  !value.applicableForType && !event.target.checked
                                    ? distributorMaster.Direct
                                    : value.applicableForType,
                              };
                            }
                          );

                          setValues({
                            ...values,
                            isApplicableForDistributor: event.target.checked,
                            strategyFeeDetails: filterStrategyFeeDetails(updateValues),
                          });
                        }}
                      />
                    </Box>
                  </Grid>

                  {values.isApplicableForDistributor && (
                    <Grid item xs={12} sm={12} md={12}>
                      <MultipleSelect
                        name="distributorIds"
                        label="Applicable Distributor(s) *"
                        items={distributorList.map((item) => ({
                          key: item.id,
                          value: `${item.aprn || 'N/A'} - ${item.name} (${item.type})`,
                        }))}
                        renderText="Selected Distributor(s)"
                      />
                    </Grid>
                  )}
                </Grid>
                {values?.strategyFeeDetails?.length > 0 &&
                  (values?.isApplicableForDirect || values?.isApplicableForDistributor) && (
                    <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                      <SubHeading
                        sx={{
                          color: 'common.blue',
                          letterSpacing: 0.5 + 'px',
                          padding: { xs: '10px 10px', sm: '10px 30px' },
                          ml: { xs: 3.5 },
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}>
                        <Typography>{`Fee Details`}</Typography>
                      </SubHeading>
                    </Grid>
                  )}
                {(values?.isApplicableForDirect || values?.isApplicableForDistributor) &&
                  (values?.strategyFeeDetails || [])?.map((strategy, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Box
                          sx={{
                            bgcolor: 'white',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.10)',
                            borderRadius: '10px',
                            pb: 3,
                            mr: { xs: 0, sm: 5 },
                            mt: { xs: 1, sm: 3 },
                          }}>
                          <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                            <Grid
                              display={'flex'}
                              alignItems={'center'}
                              justifyContent={'flex-end'}
                              item
                              xs={12}
                              sm={12}
                              md={12}>
                              {/* <MFCheckbox
                                name={`strategyFeeDetails.${index}.isOtherFeeApplicable`}
                                label="Is Applicable For Others"
                                sx={{ letterSpacing: '1px' }}
                                onChange={(event) => {
                                  setValues((values) => {
                                    return {
                                      ...values,
                                      strategyFeeDetails: (values?.strategyFeeDetails || []).map(
                                        (val) => {
                                          if (
                                            strategy.feeId === val.feeId &&
                                            strategy.applicableForType === val.applicableForType
                                          ) {
                                            return {
                                              ...val,
                                              isOtherFeeApplicable: event.target.checked,
                                            };
                                          } else if (
                                            strategy.feeId !== val.feeId &&
                                            strategy.applicableForType === val.applicableForType
                                          ) {
                                            return {
                                              ...val,
                                              isOtherFeeApplicable: false,
                                            };
                                          } else {
                                            return val;
                                          }
                                        }
                                      ),
                                    };
                                  });
                                }}
                              /> */}

                              <IconButton
                                disabled={values?.strategyFeeDetails?.length === 1}
                                onClick={() => {
                                  setDeleteId(strategy?.feeId || '');
                                  setDialogBox(true);
                                }}>
                                <DeleteOutlineIcon
                                  titleAccess="Delete Form"
                                  sx={{ cursor: 'pointer' }}
                                  color={
                                    filterStrategyFeeDetails(values?.strategyFeeDetails)?.length ===
                                    1
                                      ? 'disabled'
                                      : 'error'
                                  }
                                  fontSize="small"
                                />
                              </IconButton>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                              <MFTextField
                                name={`strategyFeeDetails.${index}.fee`}
                                label="Management fee *"
                                placeholder="Enter Management Fee"
                                endAdornment={
                                  values?.strategyFeeDetails?.[index]?.isOtherFeeApplicable && (
                                    <InputAdornment position="end">%</InputAdornment>
                                  )
                                }
                              />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                              <MFTextField
                                name={`strategyFeeDetails.${index}.exitLoad`}
                                label="Exit Load "
                                placeholder="Enter Exit Load"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <MFTextField
                                name={`strategyFeeDetails.${index}.hurdleRate`}
                                label={`Hurdle Rate ${
                                  values?.strategyFeeDetails?.[index]?.isOtherFeeApplicable
                                    ? '*'
                                    : ''
                                }`}
                                placeholder="Enter Hurdle Rate"
                                endAdornment={
                                  values?.strategyFeeDetails?.[index]?.isOtherFeeApplicable && (
                                    <InputAdornment position="end">%</InputAdornment>
                                  )
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <MFTextField
                                name={`strategyFeeDetails.${index}.profitShare`}
                                label={`Profit Share ${
                                  values?.strategyFeeDetails?.[index]?.isOtherFeeApplicable
                                    ? '*'
                                    : ''
                                }`}
                                placeholder="Enter Profit Share"
                                endAdornment={
                                  values?.strategyFeeDetails?.[index]?.isOtherFeeApplicable && (
                                    <InputAdornment position="end">%</InputAdornment>
                                  )
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} display={'flex'} alignItems={'center'}>
                              {/* {change here} */}
                              <UseRadioGroup
                                onChange={(e) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    strategyFeeDetails: prevValues.strategyFeeDetails.map(
                                      (value) => {
                                        if (strategy.feeId === value.feeId) {
                                          return {
                                            ...value,
                                            applicableForType: e.target.value,
                                            brokrageToDistributor: isDistributorIsDistributor(
                                              e.target.value
                                            )
                                              ? value.brokrageToDistributor
                                              : '',
                                          };
                                        }
                                        return value;
                                      }
                                    ),
                                  }));
                                }}
                                disabled={
                                  !(
                                    values.isApplicableForDirect ===
                                    values.isApplicableForDistributor
                                  )
                                }
                                formLabel="Provide Type *"
                                name={`strategyFeeDetails.${index}.applicableForType`}
                                items={Object.keys(distributorMaster).map((applicableForType) => ({
                                  label: distributorMaster[applicableForType],
                                  value: applicableForType,
                                }))}
                              />
                            </Grid>
                            {isDistributorIsDistributor(
                              values.strategyFeeDetails[index].applicableForType
                            ) && (
                              <Grid item xs={12} sm={6} md={4}>
                                <MFTextField
                                  name={`strategyFeeDetails.${index}.brokrageToDistributor`}
                                  label={`Brokerage to distributor ${
                                    !strategy.isOtherFeeApplicable ? '*' : ''
                                  }`}
                                  placeholder="Enter Brokerage to distributor"
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Box>
                      </React.Fragment>
                    );
                  })}

                {(values.isApplicableForDirect || values.isApplicableForDistributor) && (
                  <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                    <Grid
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'flex-end'}
                      item
                      xs={12}
                      sm={12}
                      md={12}>
                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        sx={{
                          color: 'primary.main',
                          fontWeight: 500,
                          fontSize: 14,
                          mr: { xs: 0, sm: 5 },
                          mt: { xs: 0.5, sm: 1 },
                        }}
                        onClick={() => {
                          const newStrategyForm = {
                            ...strategyFeilds,
                            feeId: Date.now().toString(),
                            applicableForType:
                              values.isApplicableForDirect === values.isApplicableForDistributor
                                ? ''
                                : values.isApplicableForDirect
                                ? distributorMaster.Direct
                                : values.isApplicableForDistributor
                                ? distributorMaster.Distributor
                                : '',
                          };

                          setValues((val) => {
                            return {
                              ...val,
                              strategyFeeDetails: [...val.strategyFeeDetails, newStrategyForm],
                            };
                          });
                        }}>
                        Add Fee Details
                      </Button>
                    </Grid>
                  </Grid>
                )}
                {access && (
                  <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 3 }}>
                    <MFSubmitButton label="Save" />
                  </Box>
                )}
              </>
            )}
            <ConfirmationDialog
              message={`Are you sure you want to delete the fee details ?`}
              open={dialogbox}
              setOpen={() => setDialogBox(true)}
              onSave={() => {
                setValues({
                  ...values,
                  strategyFeeDetails: filterStrategyFeeDetails(
                    values.strategyFeeDetails.map((formData) => {
                      return formData.feeId === deleteId
                        ? { ...formData, isActive: false }
                        : formData;
                    })
                  ),
                });
                setDialogBox(false);
              }}
              onCancel={() => setDialogBox(false)}
            />
          </Box>
        )}
      </Formik>
    </>
  );
}
